import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import NumpadKeyboardButton from './numpadKeyboardButton';
import { numpadKeyboardButtonTypes } from '../../../core/constants/numpadKeyboardButtonTypes';
import { userInfoStore } from '../../../store/userInfoStore';
import { handleKeyboardButtonClick } from '../../../core/helpers/handleKeyboardButtonClick';

const NumpadKeyBoard = observer(() => {
  const { setBetAmount, betAmount } = userInfoStore;

  const handleKeyboardClick = useCallback(
    (button) => {
      handleKeyboardButtonClick(button, betAmount, setBetAmount);
    },
    [setBetAmount, betAmount]
  );

  return (
    <div className='inner-numpad-wrapper'>
      {numpadKeyboardButtonTypes.map((button) => (
        <NumpadKeyboardButton key={button} handleClick={() => handleKeyboardClick(button)}>
          {button}
        </NumpadKeyboardButton>
      ))}
    </div>
  );
});
export default NumpadKeyBoard;
